import React from 'react'
import { PERMISSIONS } from 'src/config/roleConfig'
import palette from 'src/designSystem/variables/palette'
import { TextButton } from '../../Buttons/TextButton'
import { useClearFilters } from './FilterBar.hooks'

const ClearAllFiltersStyles = {
  cursor: 'pointer',
  color: palette.neutral['800'],
  fontWeight: 400,
  fontSize: 14,
  textDecoration: 'none',
  width: '80px',
  whiteSpace: 'nowrap' as const,
}

export const ClearAllFilters = (): JSX.Element => {
  const { clearFilters, hasAppliedFilters } = useClearFilters()

  if (!hasAppliedFilters) return <></>

  return (
    <TextButton
      style={ClearAllFiltersStyles}
      requiredPermissions={[PERMISSIONS.READ]}
      onClick={clearFilters}
    >
      Clear filters
    </TextButton>
  )
}
